// src/pages/about/AboutUs.jsx
import React from "react";
import "./AboutUs.css";

function AboutUs() {
  return (
    <div className="about-container">
    {/* Mission Statement */}
<section className="mission-box">
  <h2 className="mission-title">Our Mission</h2>
  <p className="mission-text">
    Dedicated to providing exceptional physiotherapy care through personalized treatment plans, state-of-the-art facilities, and evidence-based practices to help our patients achieve optimal physical well-being.
  </p>
</section>

{/* Our Journey (timeline style) */}
<section className="journey-section">
  <h2 className="section-title">Our Journey</h2>
  <div className="timeline">
    <div className="timeline-item">
      <div className="timeline-year">2021</div>
      <div className="timeline-content">
        <h3>The Beginning</h3>
        <p>
          Established our first clinic in Haldibari, where we began our mission of providing quality physiotherapy care to the community. Founded by our lead physiotherapist who brought valuable experience from prestigious clinics in Kolkata, combining metropolitan expertise with personalized local care.
        </p>
      </div>
    </div>

    <div className="timeline-item">
      <div className="timeline-year">2023</div>
      <div className="timeline-content">
        <h3>Evolution and Growth</h3>
        <p>
          Relocated to our current state-of-the-art facility, equipped with advanced therapeutic equipment and modern rehabilitation tools. This expansion allowed us to enhance our treatment capabilities and introduce specialized programs including:
        </p>
        <ul className="timeline-highlights">
          <li>Advanced orthopedic rehabilitation</li>
          <li>Specialized neurological treatment</li>
          <li>Modern electrotherapy equipment</li>
          <li>Dedicated exercise space</li>
        </ul>
      </div>
    </div>

    <div className="timeline-item">
      <div className="timeline-year">Present</div>
      <div className="timeline-content">
        <h3>Continuing Excellence</h3>
        <p>
          Today, we continue to serve our community with comprehensive physiotherapy care, combining years of expertise with modern treatment approaches. Our commitment to patient well-being remains at the heart of everything we do.
        </p>
      </div>
    </div>
  </div>
</section>

      {/* Why Choose Us */}
      <section className="why-choose-section">
        <h2 className="section-title">Why Choose Us</h2>
        <div className="why-cards">
          <div className="why-card">
            <h3>Personalized Care</h3>
            <p>We tailor every treatment plan to the individual needs and goals of our patients.</p>
          </div>
          <div className="why-card">
            <h3>Evidence-based Treatment</h3>
            <p>Our protocols are rooted in the latest research to ensure effective and safe outcomes.</p>
          </div>
          <div className="why-card">
            <h3>Modern Facilities</h3>
            <p>Enjoy state-of-the-art equipment and comfortable rehab spaces designed for optimal recovery.</p>
          </div>
          <div className="why-card">
            <h3>Experienced Team</h3>
            <p>Our clinicians undergo continuous education to stay current with evolving physiotherapy techniques.</p>
          </div>
          <div className="why-card">
            <h3>Convenient Location</h3>
            <p>Situated in a prime spot with easy access and parking, making every visit hassle-free.</p>
          </div>
          <div className="why-card">
            <h3>Flexible Scheduling</h3>
            <p>We offer extended hours and weekend appointments to fit your busy lifestyle.</p>
          </div>
        </div>
      </section>

      {/* Our Approach */}
      <section className="approach-section">
        <h2 className="section-title">Our Approach</h2>
        <p>
          We believe in holistic treatment that addresses the root causes of pain and mobility issues.
          Our therapists employ the latest techniques, stay updated through ongoing education, and
          collaborate with other healthcare professionals to provide comprehensive care.
        </p>
      </section>
    </div>
  );
}

export default AboutUs;
